module.exports = __webpack_public_path__ + "assets/img/logo-black.6cabbb44.png";